// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}@media (max-width:992px){.initial-search-visible{padding-top:99px!important}}@media (max-width:992px){.mobile-cart-visible{padding-top:51px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
